/*
* 输入长度限制
* */
export enum LENGTH_LIMIT {
    CLASS_NAME = 20,                             // 分类名称
    DEPT_NAME = 20,                              // 部门名称
    COURIER_NUMBER = 30,                         // 快递单号
    RULE_NAME = 20,                              // 告警规则名称
    SEND_VALUE = 100,                            // 告警推送地址
    LOGIN_NAME = 30,                             // 登录名称
    NICKNAME = 20,                               // 帐号昵称
    PASSWORD = 20,                               // 帐号密码
    ROLE_NAME = 20,                              // 角色名称
    ROLE_DESC = 64,                              // 告警规则名称
    INVOICE_HEAD = 64,                           // 发票抬头
    INVOICE_BUYER_ID = 20,                       // 税号或社会统一信用代码
    BUYER_ADDR = 100,                            // 注册地址
    BUYER_BANK = 100,                            // 开户银行
    INVOICE_REMARK = 100,                        // 发票备注
    BUYER_ACC = 20,                              // 开户银行帐号
    REAL_NAME = 20,                              // 真实姓名
    EMAIL = 30,                                  // 邮箱
    ADDR_DETAIL = 50,                            // 街道地址
    GOODS_NAME = 20,                             // 商品名称
    GOODS_RELEASE_NAME = 64,                     // 商品发布名称
    REMARK = 255,                                // 备注
    NUMBER = 16,                                 // 编号
}

/*
* 正则表单式类型
* */
export const PATTERN = {
    PHONE: /^(0|86|17951)?(13|14|15|16|17|18|19)[0-9]{9}$/,   // 匹配手机号码
    EMAIL: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,   // 匹配邮箱
    IMGCODE: /^[a-zA-Z0-9]{5}$/,
    PASSWORD: /^(?![\d]+$)(?![a-zA-Z]+$)(?![!@#$%^&*().]+$)[\da-zA-Z!@#$%^&*().]{6,20}$/,
    VALIDATECODE: /^[0-9]{6}$/,
    INVOICEHEAD: /\S+/,   // 发票抬头
    TAXNO: /\d+/,   // 税号
    ADDRESS: /\S+/,     // 接收地址
    BANKNAME: /\S+/,    // 开户银行
    BANKNO: /\d+/,     // 银行账号
    BIZADDRESS: /\S+/,      // 企业地址
    BIZPHONE: /\d+/,    // 企业电话
    CONTACT: /\S+/,     // 收票人
    CONTACTPHONE: /\d+/,    // 收票人电话
}
